var map = {
	"./agent.png": "19de",
	"./akcept.svg": "43c8",
	"./alef.svg": "3287",
	"./alpha.svg": "79cb",
	"./b1.svg": "2210",
	"./b2.svg": "a3c1",
	"./b3.svg": "d6ab",
	"./b4.svg": "ec2c",
	"./banner.png": "ec24",
	"./chevron-down.svg": "d742",
	"./chevron-left.svg": "254a",
	"./chevron-right.svg": "4672",
	"./email.svg": "9055",
	"./file-blue.svg": "1c06",
	"./file.svg": "46c7",
	"./fonts/cyrillic-ext.woff2": "7124",
	"./fonts/cyrillic.woff2": "9f8f",
	"./fonts/greek-ext.woff2": "da24",
	"./fonts/greek.woff2": "6a75",
	"./fonts/latin-ext.woff2": "e35e",
	"./fonts/latin.woff2": "cbab",
	"./fonts/math.woff2": "c244",
	"./fonts/roboto.css": "2163",
	"./fonts/symbols.woff2": "e66e",
	"./fonts/vietnamese.woff2": "88ab",
	"./g1.svg": "ee58",
	"./g2.svg": "392e",
	"./g3.svg": "5c69",
	"./gpb.svg": "e954",
	"./gtb.svg": "3118",
	"./kamkom.svg": "8bd6",
	"./logo.svg": "9b19",
	"./msp.svg": "3ff3",
	"./mts.svg": "2d48",
	"./phone.svg": "001e",
	"./psb.svg": "2694",
	"./realist.svg": "2566",
	"./sber.svg": "9dc4",
	"./sbnk.svg": "cd52",
	"./souz.svg": "64c7",
	"./spb.svg": "5c0d",
	"./telegram.svg": "7dd3",
	"./tsb.svg": "f155",
	"./user.svg": "0f62",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";